module.exports = __webpack_public_path__ + "assets/img/smartTV-icon1.9998b3e3.png";